function IntegerInput({
  value,
  onChange,
  ...props
}: {
  value: number | undefined;
  onChange: Function;
  [key: string]: any;
}) {
  return (
    <input
      type="text"
      value={(value ?? "") + ""}
      onChange={({ target }) => {
        if (target.value === "") {
          onChange(undefined);
          return;
        }

        if (target.value.match(/^\d+$/) && target.value.length <= 15)
          onChange(+target.value);
      }}
      {...props}
    />
  );
}

export default IntegerInput;
